/* @flow */

/* 
 * This module is responsible for onboarding new users
 */

let page = ((document.querySelector('#page'): any): HTMLElement);
let dialog = ((document.querySelector('#onboard-dialog'): any): HTMLElement);
let yesOnboarding = ((document.querySelector('#onboard-yes'): any): HTMLElement);
let noOnboarding = ((document.querySelector('#onboard-no'): any): HTMLElement);

if (!localStorage.getItem('onboarded-metrics')) {
    localStorage.setItem('onboarded-metrics', 'yes');
    dialog.showModal()
    page.classList.add('blur')
}

let guide = new Driver({
    showButtons: false,         // Do not show control buttons in footer
    allowClose: false,          // Whether the click on overlay should close or not
    overlayClickNext: true,     // Whether the click on overlay should move next
})

let regionGuide = new Driver({
    showButtons: false,
    allowClose: false,
    overlayClickNext: true
})

// start guide triggers on first map load and offers to explain how to use metrics and timeline
function startGuide() {
    const menu = document.querySelector('#individual-features .content')
    if (menu && menu.style.display !== 'block') {
        document.getElementById('expand-feature-combinations').click()
    }
    guide.defineSteps([{
        element: '#individual-features',
        popover: {
            description: 'The Metrics menu is used for selecting metrics to render the heat map for.',
            position: 'right'
        }
    }, {
        element: '#available_stats',
        popover: {
            description: 'To start using the app, select one or more metrics from this menu. These metrics are grouped by topics. Selecting a topic opens a secondary menu with individual metrics.',
            position: 'right',
        },
        onNext: () => {
            // expand category
            guide.preventMove()
            setTimeout(() => {
                document.getElementById('housing_complex').click()
                guide.moveNext()
            }, 100)
        }
    }, {
        element: '#side_menu_expansion',
        popover: {
            description: 'Within a topic, select one or more metrics you wish to generate a heat map for.',
            position: 'right'
        },
        onNext: () => {
            // select metric
            guide.preventMove()
            setTimeout(() => {
                document.getElementById('housing_home_price_basic').click()
                guide.moveNext()
            }, 100)
        }
    }, {
        element: '#selected_stats',
        popover: {
            description: 'Selected metrics are shown in the area above.',
            position: 'right'
        },
        onNext: () => {
            // highlight metric weight
            guide.preventMove()
            document.querySelector('.chip_vote span:first-child').style.display = 'inline'
            document.querySelector('.chip_vote span:last-child').style.display = 'inline'
            document.querySelector('.chip_vote').style.width = '62px'
            setTimeout(() => guide.moveNext(), 100)
        }
    }, {
        element: '#chip-housing--home_price',
        popover: {
            description: 'Each metric is represented by a tag with a weight shown to the left of metric\'s name. Weights can be adjusted by using the arrows that appear when hovering over the weight. Higher weight gives more importance to the metric relative to other metrics.',
            position: 'right'
        },
        onNext: () => {
            // select metric
            guide.preventMove()
            setTimeout(() => {
                document.querySelector('#downvote-chip-housing--home_price').click()
                guide.moveNext()
            }, 100)
        }
    }, {
        element: '#chip-housing--home_price',
        popover: {
            description: 'You can give metric a negative weight, negating its result. For example, giving negative weight to <b>Home Price</b> ranks areas with lowest home price highest (most desirable).',
            position: 'right'
        },
        onNext: () => {
            guide.preventMove()
            document.querySelector('.chip_vote span:first-child').style.display = ''
            document.querySelector('.chip_vote span:last-child').style.display = ''
            document.querySelector('.chip_vote').style.width = ''
            setTimeout(() => {
                guide.moveNext()
                document.getElementById('compute-stats-btn').click()
            }, 100)

            document.querySelector('#edit-chip-housing--home_price').style.display = 'inline'
        }
    }, {
        element: '#chip-housing--home_price',
        popover: {
            description: 'Hovering over the metric will show a filter button on the right, allowing you to adjust filters, or modify metric parameters (including changing the metric to delta format, in order to measure changes over time instead of year-specific values).',
            position: 'right'
        },
        onNext: () => {
            document.querySelector('#edit-chip-housing--home_price').style.display = ''
        }
    }, {
        element: '#compute-stats-btn',
        popover: {
            description: '"Compute" button will generate a heat map that takes all of your selected metrics into account, creating a personalized recommendation of areas to invest in.',
            position: 'right'
        }
    }, {
        element: '#timeline-year',
        popover: {
            description: 'By default the heat map is generated for current year. You can open the timeline by clicking on the year shown.',
            position: 'left'
        },
        onNext: () => {
            // show timeline
            guide.preventMove()
            document.getElementById('timeline-year').click()
            setTimeout(() => guide.moveNext(), 100)
        }
    }, {
        element: '#timeline-container',
        popover: {
            description: 'Timeline allows you to view how the heat map changes over time, as well as see future predictions based on the metrics you selected.',
            position: 'top'
        }
    }, {
        element: '#timeline-history-events',
        popover: {
            description: 'Important historical events with significant real estate impact are marked as Black Swans on the timeline.',
            position: 'top'
        }
    }, {
        element: '#timeline-slider-dragbar',
        popover: {
            description: 'You can move the slider to change the current year, automatically updating the heat map.',
            position: 'top'
        },
        onNext: () => {
            // show delta arrows
            guide.preventMove()
            document.getElementById('timeline-slider-delta-left').style.display = 'block'
            document.getElementById('timeline-slider-delta-right').style.display = 'block'
            setTimeout(() => {
                guide.moveNext()
                guide.refresh()
            }, 100)
        }
    }, {
        element: '#timeline-slider',
        popover: {
            description: 'Hovering over the slider will reveal arrows for changing the timeframe, effectively changing the heat map from showing data for a given year to showing percentage change between years.',
            position: 'top'
        },
        onNext: () => {
            // hide delta arrows
            guide.preventMove()
            document.getElementById('timeline-slider-delta-left').style.display = ''
            document.getElementById('timeline-slider-delta-right').style.display = ''
            setTimeout(() => guide.moveNext(), 100)
        }
    }, {
        element: '#timeline-bwd i',
        popover: {
            description: 'Use the arrows on the edge of the timeline to change timeline window.',
            position: 'top'
        },
        onNext: () => {
            // hide timeline
            guide.preventMove()
            setTimeout(() => {
                document.getElementById('timeline-year').click()
                guide.moveNext()
            }, 100)
        }
    }, {
        element: '#leaflet-controls-title',
        popover: {
            description: 'Use Region Dashboard to change zoom settings and overlays, mark locations on the map, take notes, and perform region-specific analysis.',
            position: 'right'
        }
    }, {
        element: '#show-onboard-region i',
        popover: {
            description: 'Region Dashboard has its own help bubble if you would like to learn more about it as well.',
            position: 'right'
        }
    }, {
        element: '.main-search',
        popover: {
            description: 'Use the search to quickly navigate to a specific address, zip code, city, state, or marker you created earlier.',
            position: 'bottom'
        }
    }, {
        element: '#show-social-btns i',
        popover: {
            description: 'Share your maps with others or generate an infographic to use on forums and blogs.',
            position: 'left'
        }
    }, {
        element: '#show-onboard-metrics i',
        popover: {
            description: 'If you ever need to see this guide again, use this help bubble.',
            position: 'right'
        }
    }])
    guide.start()
}

document.getElementById('show-onboard-metrics').addEventListener('click', () => {
    setTimeout(() => { // a hack to prevent user event from getting associated with guide dismissal
        startGuide()
    }, 100)
})

yesOnboarding.addEventListener('click', () => {
    page.classList.remove('blur')
    dialog.close()
    setTimeout(() => { // a hack to prevent user event from getting associated with guide dismissal
        startGuide()
    }, 100)
})

noOnboarding.addEventListener('click', () => {
    page.classList.remove('blur')
    dialog.close()
    setTimeout(() => { // a hack to prevent user event from getting associated with guide dismissal
        guide.highlight({
            element: '#show-onboard-metrics i',
            popover: {
                title: 'skip',
                description: 'If you ever change your mind, use this button to show onboarding again.'
            },
            position: 'right'
        })
    }, 100)
})

// region guide pops up when user first changes region
function startRegionGuide() {
    const menu = document.getElementById('leaflet-controls-content')
    if (menu && menu.style.display !== 'block') {
        document.getElementById('expand-region-dashboard').click()
    }
    regionGuide.defineSteps([{
        element: '#leaflet-controls-content',
        popover: {
            description: 'Region Dashboard menu allows you to change the region, granularity, and view region-specific data.',
            position: 'right'
        }
    }, {
        element: '#region-selector',
        popover: {
            description: 'You can change the region either by clicking on an area on the map or using this region selector. The region selector is useful for zooming back out.',
            position: 'right',
        }
    }, {
        element: '#search-area',
        popover: {
            description: 'You can also search for a region to switch to it. This is useful when comparing multiple cities or states.',
            position: 'bottom'
        }
    }, {
        element: '#granule-selector',
        popover: {
            description: 'Granularity selector allows you to split up the region into smaller chunks for more granular analysis. You can switch between county, zip code or tract. Changing granularity allows you to explore relationships between areas that might not be apparent at other granularities.',
            position: 'right'
        },
    }, {
        element: '#map-layer-selector',
        popover: {
            description: 'Map layer selector allows you to change the map layer. You can switch between street map, transportation, topology map, and satellite view.',
            position: 'right'
        },
    }, {
        element: '#region-heatmap-layer',
        popover: {
            description: 'Below that is the heatmap toggle, because sometimes the heatmap gets in the way, especially for layers like satellite view.',
            position: 'right'
        },
    }, {
        element: '#region-distance',
        popover: {
            description: 'Below that is the distance measurement tool, which allows you to ballpark distances and commute times.',
            position: 'right'
        },
    }, {
        element: '#region-options',
        popover: {
            description: "Finally, you will find region-specific controls in this section, which allow you to learn about the region, analyze regional trends, as well as find region-specific markers and documents.",
            position: 'right'
        },
    }, {
        element: '#show-onboard-region',
        popover: {
            description: 'If you ever need to see this guide again, use this help bubble.',
            position: 'right'
        }
    }])
    regionGuide.start()
}
document.getElementById('show-onboard-region').addEventListener('click', () => {
    setTimeout(() => { // a hack to prevent user event from getting associated with guide dismissal
        startRegionGuide()
    }, 100)
})